module.exports = __webpack_public_path__ + "static/img/Heavy_Rain.f93415ee.png";